import React, { Fragment, useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { setLoading } from "../../utils";

import { postCookie } from "../../api";
import { SEND_OTP, VALIDATE_OTP } from "../../api/endpoints";
import {
  setCookie,
  parseJwt,
  getCookie,
  getItemFromLocalStorage,
} from "../../utils";
import {
  SALON_HOME,
  TIME_DURATION,
  TERMS_CONDITION,
  PRIVACY_POLICY,
  SALON_ONBOARDING,
} from "../../constants";
import LoginImage from "../../assets/LoginImage.jpg";
import LoginLogo from "../../assets/login_logo.svg";

import Close from "../../assets/close.svg";

import TextBox from "../../components/common/TextBox";
import Button from "../../components/common/Button";
import Footer from "../../components/common/Footer";

import "./OtpLogin.scss";

function Login({ history }) {
  const [otpObject, updatePhoneNumberUserName] = useState(new FormData());
  const [otpObjectString, updatePhoneNumberUserNameStrObj] = useState({
    username: "",
    mobile: "",
    code: "",
  });
  const [showSalonRegisterMesage, toggleSalonRegisterMessage] = useState(false);
  const [tncCheck, checkTnx] = useState(true);
  const [showOTPConfirm, confirmOTPScreenShow] = useState(false);
  const [showResendButton, enableResendButton] = useState(false);
  let [timer, updateTimer] = useState(60);

  const callBack = ({ statusText }) => {
    confirmOTPScreenShow(true);
  };
  useEffect(() => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage("away");
    }
    const cookie = getCookie("accessToken");
    if (cookie) {
      window.history.go(-1);
    }
  }, []);
  const getOtp = () => {
    setLoading();
    otpObject.set("uid", localStorage.getItem("fcmToken"));
    postCookie({ callBack, params: otpObject, endpoint: SEND_OTP });
    enableResendButton(false);
    const interVal = setInterval(() => {
      timer = timer - 1;
      updateTimer(timer);
    }, 1000);
    setTimeout(() => {
      clearInterval(interVal);
      enableResendButton(true);
      updateTimer(60);
    }, TIME_DURATION);
  };

  const updateOtpDetails = ({ key, value }) => {
    otpObject.set(key, key === "mobile" ? `+91${value}` : value);
    const otpObjectStringVar = JSON.parse(JSON.stringify(otpObjectString));
    otpObjectStringVar[key] = value;
    updatePhoneNumberUserNameStrObj(otpObjectStringVar);
    updatePhoneNumberUserName(otpObject);
    toggleSalonRegisterMessage(false);
  };

  const confirmOTPFunction = () => {
    postCookie({
      callBack: confirmOTP,
      params: otpObject,
      endpoint: VALIDATE_OTP,
    });
  };

  const confirmOTP = ({ data: { token }, status }) => {
    if (status === 200) {
      setCookie("accessToken", token, 17);
      const { salon_id } = parseJwt() || {};
      if (salon_id) {
        history.push(`${SALON_HOME}`);
        return;
      }
      toggleSalonRegisterMessage(true);
      return;
    }
  };

  const redirectUserToNewApp = () => {
    const deviceType = getItemFromLocalStorage("deviceType");
    if (deviceType === "android") {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.dazzleapp&hl=en_IN&gl=US";
      return;
    }
    window.location.href = "https://apps.apple.com/us/app/nearz/id1549902743";
    return;
  };
  return (
    <div className="otp-login">
      {showOTPConfirm ? (
        <div className="otp-confirm">
          <img
            className="salon-login-image"
            src={LoginImage}
            alt={LoginImage}
          />
          <img
            src={Close}
            className="close"
            onClick={() => confirmOTPScreenShow(false)}
          />
          <div className="login-container">
            <div className="sign-in-app-name">Dazzle</div>
            <div className="otp-info-text">
              {`Please enter your 4 digit OTP received on`}
              <div>+91-{otpObjectString.mobile}</div>
            </div>
            <div className="otp-enter">
              <TextBox
                className="otp-input"
                type="number"
                id="dad"
                value={otpObjectString.code && otpObjectString.code}
                maxlength={4}
                onChange={({ target: { value } }) => {
                  updateOtpDetails({
                    key: "code",
                    value,
                  });
                }}
              />
            </div>
            <div>
              Didn’t receive the OTP?{" "}
              <div
                className={
                  showResendButton ? "resend-button" : "resend-button disabled"
                }
                onClick={getOtp}
              >
                Resend OTP {!showResendButton && `in ${timer} seconds`}
              </div>
            </div>
          </div>
          {showSalonRegisterMesage && (
            <>
              <span className={"resend-button"}>
                Looks Like you are not registered yet.{" "}
              </span>
              <Button
                text={"Click here to Register your salon"}
                className={"register-salon"}
                onClick={() => {
                  history.push(`${SALON_ONBOARDING}/details`);
                }}
              />
              <br />
              <br />
              <span className={"resend-button"}>
                If you are one of our amazing customers, please{" "}
              </span>
              <Button
                className={"register-salon"}
                onClick={redirectUserToNewApp}
                text="click here to"
              />
              <span className={"resend-button"}>
                {" "}
                to update and continue enjoying our seemless discounts
              </span>
            </>
          )}
          <Footer>
            <Button
              text="Confirm OTP"
              onClick={confirmOTPFunction}
              disabled={
                !(otpObjectString.code && otpObjectString.code.length === 4)
              }
              type="next"
            />
          </Footer>
        </div>
      ) : (
        <Fragment>
          {/* <div onClick={posts}>pm</div> */}
          <img
            className="salon-login-image"
            src={LoginImage}
            alt={LoginImage}
          />
          <img className="login-logo" src={LoginLogo} alt={LoginLogo} />
          <div className="login-container">
            <div className="sign-in-continue">
              Please sign/login to continue
            </div>
            <div>
              <TextBox
                className="name-field"
                type="text"
                id="name-field"
                value={otpObjectString.username}
                onChange={({ target: { value } }) =>
                  updateOtpDetails({ key: "username", value })
                }
                placeholder="Enter name"
              />
            </div>
            <div>
              <TextBox
                type="number"
                className="number-field"
                specification="+91"
                value={otpObjectString.mobile}
                onChange={({ target: { value } }) => {
                  value.length < 11 &&
                    updateOtpDetails({
                      key: "mobile",
                      value: value,
                    });
                }}
                placeholder="Enter phone number"
              />
            </div>
            <div>
              <TextBox
                className="number-field"
                value={otpObjectString.referral_code}
                onChange={({ target: { value } }) =>
                  updateOtpDetails({ key: "referral_code", value })
                }
                placeholder="Enter referral code (optional)"
              />
            </div>
            <div
              className="tnc-container"
              onClick={(event) => {
                checkTnx(event.target.checked);
              }}
            >
              <span className="tnc-text">
                By continuing our services, you agree to{" "}
                <a
                  className="tnc-links"
                  target="_blank"
                  onClick={() => (window.location.href = TERMS_CONDITION)}
                >
                  terms & conditions
                </a>{" "}
                and{" "}
                <span
                  className="tnc-links"
                  onClick={() => (window.location.href = PRIVACY_POLICY)}
                >
                  privacy policy
                </span>
              </span>
            </div>
            <div id="container"></div>
            <Footer>
              <Button
                text="Login"
                onClick={getOtp}
                disabled={
                  !(
                    otpObjectString.username.length &&
                    otpObjectString.mobile.length === 10 &&
                    tncCheck
                  )
                }
                type="next"
              />
            </Footer>
          </div>
        </Fragment>
      )}
    </div>
  );
}

Login.propTypes = {
  history: PropTypes.shape,
};

export default withRouter(Login);
